import { render, staticRenderFns } from "./NavigationContainerComponent.vue?vue&type=template&id=7c7859e6&scoped=true&lang=pug"
import script from "./NavigationContainerComponent.vue?vue&type=script&lang=ts"
export * from "./NavigationContainerComponent.vue?vue&type=script&lang=ts"
import style0 from "./NavigationContainerComponent.vue?vue&type=style&index=0&id=7c7859e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7859e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c7859e6')) {
      api.createRecord('7c7859e6', component.options)
    } else {
      api.reload('7c7859e6', component.options)
    }
    module.hot.accept("./NavigationContainerComponent.vue?vue&type=template&id=7c7859e6&scoped=true&lang=pug", function () {
      api.rerender('7c7859e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navigation/NavigationContainer/NavigationContainerComponent.vue"
export default component.exports